module.exports = __webpack_public_path__ + "10acf275088cf36ffac6bb5a13e4193b.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-05-23/whats-new.html
// module id = 2288
// module chunks = 0